// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"AddToCartButton_paginationPageDropdownWrap__B1gF1","addToCartButton":"AddToCartButton_addToCartButton__Qr2q8","button":"AddToCartButton_button__zvPTv"};